import React from 'react';
import { Box } from '@mui/material';
import CBOnboarding from '../organization_dashboard/CBOnboarding';
const CampaignBuilderPage = ({ organization, onClose }) => {
  return (
    <Box p={2}>
      <CBOnboarding organization={organization} onComplete={onClose} />
    </Box>
  );
};

export default CampaignBuilderPage;